import React, { useState } from "react";
import searchIcon from "../../assets/img/search.png";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PopUpModal from "../popupmodal/PopUpModal";
import logo from "../../assets/img/timber_logo.png";
import deleteIcon from "../../assets/img/delete.svg";

const fetchSupplierDetails = async () => {
  return await axios.get(`${process.env.REACT_APP_HOST}/suppliers`);
};

const ViewSupplier = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [countryFilter, setCountryFilter] = useState("");
  const [foreignBankChargeFilter, setForeignBankChargeFilter] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [countryOfOrigin, setCountryOfOrigin] = useState();
  const handleChange = (date) => {
    setSelectedMonth(date);
  };

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };

  // Fetch data
  const { data, isLoading, isError, refetch } = useQuery(
    "data",
    fetchSupplierDetails
  );

  let details = (data && data?.data) || [];

  // Convert selected month (Date object) to abbreviated month name (e.g., "Jan")
  const getSelectedMonthString = (selectedMonth) => {
    return selectedMonth
      ? selectedMonth.toLocaleString("default", { month: "short" })
      : null;
  };

  // Filter Logic Apply

  const filteredData =
    details?.filter((val) => {
      const supplierName = String(val?.supplierName).toLowerCase();
      const supplierId = String(val?.supplierId).toLowerCase();
      const term = (searchTerm || "").toLowerCase();
      const matchesSearchTerm =
        supplierName.includes(term) ||
        supplierId.includes(term);
      const matchesCountryFilter = countryOfOrigin
        ? val?.countryOfOrigin === countryOfOrigin
        : true;
      return (matchesSearchTerm && matchesCountryFilter);
    }) || [];

  // Download Excel
  const downloadExcel = () => {
    // Define headers
    const headers = [
      "S.No",
      "SUPPLIER ID",
      "SUPPLIER NAME",
      "MOBILE NUMBER",
      "EMAIL ID",
      "COUNTRY OF ORIGIN",
      "COUNTRY CONSIGNED FROM",
      "FOREIGN BANK CHARGE",
      "FORWARD CONTRACT NO",
      "RESULTANT CURRENCY",
      "TREASURY REF NUMBER",
      "TERMS",
    ];

    // Map data to match the headers order
    const formattedData =
      filteredData?.map((item, index) => ({
        "S.No": index + 1,
        "SUPPLIER ID": item?.supplierId || "",
        "SUPPLIER NAME": item?.supplierName || "",
        "MOBILE NUMBER": item?.mobileNo || "",
        "EMAIL ID": item?.emailId || "",
        "COUNTRY OF ORIGIN": item?.countryOfOrigin || "",
        "COUNTRY CONSIGNED FROM": item?.countryConsignedFrom || "",
        "FOREIGN BANK CHARGE": item?.foreignBankCharge || "",
        "FORWARD CONTRACT NO": item?.forwardContractNo || "",
        "RESULTANT CURRENCY": item?.resultantCurrency || "",
        "TREASURY REF NUMBER": item?.treasuryRefNumber || "",
        TERMS: item?.terms || "",
      })) || [];

    // Create a new workbook and a worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, "View Customer.xlsx");
  };

  // DELETE API
  // Delete a user by ID
  const deleteUser = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_HOST}/suppliers/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error deleting user with ID ${id}:`, error);
      throw error;
    }
  };

  const deleteUsers = async (ids) => {
    try {
      const results = await Promise.all(
        ids?.map(async (id) => {
          return await deleteUser(id);
        })
      );
      return results; // Return all results after deletion
    } catch (error) {
      console.error("Error deleting multiple users:", error.message);
      throw new Error("Failed to delete multiple users");
    }
  };
  // Mutation to delete users
  const mutation = useMutation({
    mutationFn: deleteUsers,
    onSuccess: () => {
      setDeletePopUp(true);
      setSelectedRows([]);
      refetch();
    },
    onError: (error) => {
      console.error("Error deleting rows:", error);
      alert("Error deleting rows");
    },
  });

  // Handle checkbox change
  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows?.includes(id);
      if (isSelected) {
        return prevSelectedRows?.filter((rowId) => rowId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };
  // Handle delete button click
  const handleDelete = () => {
    if (selectedRows?.length === 0) {
      alert("No rows selected");
      return;
    }
    mutation.mutate(selectedRows);
  };

  // DELETE API END

  return (
    <>
      <div className="view_customer_main_section">
        <div className="headerTimeLine px-3 py-3">
          <div className="row">
            <div className="col-12 col-lg-4 mb-3 mb-lg-0">
              <div className="agent-search-block">
                <input
                  type="search"
                  className="table-search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="search by Name, ID"
                  title="search by name, id"
                />
                <div className="image_icon">
                  <img
                    src={searchIcon}
                    style={{ width: "100%", height: "100%" }}
                    alt="search-image"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-8 mb-3 mb-lg-0">
              <div className="d-flex flex-wrap align-items-center justify-content-lg-end gap-2">
                <select
                  className="view_customer_status"
                  onChange={(event) => {
                    setCountryOfOrigin(event.target.value);
                  }}
                >
                  <option value="">Country Of Origin</option>
                  {[
                    ...new Set(filteredData?.map((data) => data?.countryOfOrigin)),
                  ].map((countryOfOrigin, index) => {
                    return (
                      <>
                        <option key={index} value={countryOfOrigin}>
                          {countryOfOrigin}
                        </option>
                      </>
                    );
                  })}
                </select>

                {/* <DatePicker 
                  selected={selectedMonth}
                  onChange={handleChange}
                  dateFormat="MMM"
                  showMonthYearPicker
                  placeholderText="MONTH"
                  className="view_customer_status"
                /> */}
                {/* <select
                  className="view_customer_status"
                  name="salesMode"
                  onChange={(e) => {
                    setCountryFilter(e.target.value);
                  }}
                >
                  <option value="">SALES</option>
                  <option value="CASH">CASH</option>
                  <option value="CREDIT">CREDIT</option>
                </select> */}

                <button
                  className="view_customer_download_button"
                  onClick={() => {
                    downloadExcel();
                  }}
                >
                  DOWNLOAD
                </button>
                {selectedRows?.length !== 0 ? (
                  <div className="add-user-btn-block">
                    <button
                      className="new-user-btn"
                      onClick={() => {
                        setPopupOpen(true);
                      }}
                    >
                      DELETE
                    </button>
                    <div className="image_icon">
                      <img src={deleteIcon} className="img-icon" alt="Delete" />
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          {/* <div className="px-5 d-flex justify-content-between">
            <div className="view_customer_status_block"></div>
          </div> */}
        </div>
        <div className="view_customer_table_block">
          <div className="table-responsive m-3">
            <table className="table" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th className="view_customer_table_heading --first-head">
                    SELECT
                  </th>
                  <th className="view_customer_table_heading">S.NO</th>
                  <th className="view_customer_table_heading">SUPPLIER NAME</th>
                  <th className="view_customer_table_heading">MOBILE NUMBER</th>
                  <th className="view_customer_table_heading">EMAIL ID</th>
                  <th className="view_customer_table_heading">COUNTRY OF ORIGIN</th>
                  <th className="view_customer_table_heading">COUNTRY CONSIGNED FROM</th>
                  <th className="view_customer_table_heading">FOREIGN BANK CHARGE</th>
                  <th className="view_customer_table_heading">FORWARD CONTRACT NO</th>
                  <th className="view_customer_table_heading">RESULTANT CURRENCY</th>
                  <th className="view_customer_table_heading">TREASURY REF NUMBER</th>
                  <th className="view_customer_table_heading --last-head">
                    TERMS
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <>
                    <h6 className="p-3" style={{ color: "#543310" }}>
                      L O A D I N G . . .{" "}
                    </h6>
                  </>
                ) : filteredData && filteredData?.length > 0 ? (
                  filteredData &&
                  filteredData?.map((item, i) => {
                    return (
                      <>
                        <tr
                          key={i}
                          onClick={() => {
                            navigate("/addSupplier", { state: item });
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="view_customer_table_data">
                            <div
                              className="d-flex align-items-center justify-content-center"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={selectedRows?.includes(
                                  item?.supplierId
                                )}
                                onChange={() =>
                                  handleCheckboxChange(item?.supplierId)
                                }
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </td>
                          <td className="view_customer_table_data">{i + 1}</td>
                          <td className="view_customer_table_data">
                            {item?.supplierName || "-"}
                          </td>
                          <td className="view_customer_table_data">
                            {item?.mobileNo || "-"}
                          </td>
                          <td className="view_customer_table_data">
                            {item?.emailId || "-"}
                          </td>
                          <td className="view_customer_table_data">
                            {item?.countryOfOrigin || "-"}
                          </td>
                          <td className="view_customer_table_data">
                            {item?.countryConsignedFrom || "-"}
                          </td>
                          <td className="view_customer_table_data">
                            {item?.foreignBankCharge || "-"}
                          </td>
                          <td className="view_customer_table_data">
                            {item?.forwardContractNo || "-"}
                          </td>
                          <td className="view_customer_table_data">
                            {item?.resultantCurrency || "-"}
                          </td>
                          <td className="view_customer_table_data">
                            {item?.treasuryRefNumber || "-"}
                          </td>
                          <td className="view_customer_table_data">
                            {item?.terms || "-"}
                          </td>
                        </tr>
                      </>
                    );
                  })
                ) : (
                  <>
                    <h6>NO Records Found</h6>
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <PopUpModal isOpen={isPopupOpen} onClose={togglePopup}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-1">
          <h6 className="popup-content mb-3">
            Are you sure to delete the supplier detail?
          </h6>
          <div className="d-flex justify-content-center gap-5 mb-3">
            <button
              className="user-delete-button"
              onClick={() => {
                handleDelete();
                setPopupOpen(false);
              }}
            >
              OK
            </button>
            <button
              className="user-delete-button"
              onClick={() => {
                setPopupOpen(false);
              }}
            >
              NO
            </button>
          </div>
        </div>
      </PopUpModal>

      <PopUpModal isOpen={deletePopUp}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-1">
          <h6 className="popup-content mb-3">
            Supplier has been deleted successfully
          </h6>
          <button
            className="user-delete-button mb-3"
            onClick={() => {
              setDeletePopUp(false);
            }}
          >
            OK
          </button>
        </div>
      </PopUpModal>
    </>
  );
};

export default ViewSupplier;
